import {put,takeLatest,call} from 'redux-saga/effects';
import * as categoryService from "../../../services/categoryService";
import {
    GET_CATEGORIES,
    GET_CATEGORIES_SUCCESS,
    GET_CATEGORIES_ERROR
}
    from "../../actions/category";

function* getCategoriesSaga(action) {
    try {
        const data=yield call(categoryService.GetCategories,action.payload)
        yield put({
            type: GET_CATEGORIES_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_CATEGORIES_ERROR,error: error.data
        });
    }
}

export function* getCategoriesSagaWatcher() {
    yield takeLatest(GET_CATEGORIES,getCategoriesSaga);
}